import * as THREE from 'three';

import type { ManipulatorAxis } from './types';

function axisPointFromRadians(
  axis: ManipulatorAxis,
  angleRadians: number,
  radius: number,
): THREE.Vector3 {
  const cos = Math.cos(angleRadians) * radius;
  const sin = Math.sin(angleRadians) * radius;

  switch (axis) {
    case 'x':
      return new THREE.Vector3(0, cos, sin);
    case 'y':
      return new THREE.Vector3(sin, 0, cos);
    case 'z':
      return new THREE.Vector3(cos, sin, 0);
  }
}

export function axisIndexFromKey(axis: ManipulatorAxis): number {
  switch (axis) {
    case 'x':
      return 0;
    case 'y':
      return 1;
    case 'z':
      return 2;
  }
}

export function normalizeDegrees(value: number): number {
  if (!Number.isFinite(value)) return 0;
  let normalized = value;
  while (normalized >= 180) normalized -= 360;
  while (normalized < -180) normalized += 360;
  return normalized;
}

export function axisNormalVector(axis: ManipulatorAxis): THREE.Vector3 {
  switch (axis) {
    case 'x':
      return new THREE.Vector3(1, 0, 0);
    case 'y':
      return new THREE.Vector3(0, 1, 0);
    case 'z':
      return new THREE.Vector3(0, 0, 1);
  }
}

export function axisPointFromDegrees(
  axis: ManipulatorAxis,
  angleDegrees: number,
  radius: number,
): THREE.Vector3 {
  return axisPointFromRadians(axis, THREE.MathUtils.degToRad(angleDegrees), radius);
}

export function angleDegreesFromLocalPoint(
  axis: ManipulatorAxis,
  point: THREE.Vector3,
): number {
  switch (axis) {
    case 'x':
      return normalizeDegrees(THREE.MathUtils.radToDeg(Math.atan2(point.z, point.y)));
    case 'y':
      return normalizeDegrees(THREE.MathUtils.radToDeg(Math.atan2(point.x, point.z)));
    case 'z':
      return normalizeDegrees(THREE.MathUtils.radToDeg(Math.atan2(point.y, point.x)));
  }
}
